import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  CertificateOfInspectionId,
  Exit,
  GateAway,
  GrantPeriod,
  GrantedArea,
  LicensePlate,
  NumberOfVehicleLicensesIssued,
  Team,
  VehicleName,
  VehicleRegistrationCertificateId,
} from "./_fields";

type ExternalBusinessVehicleCardLongTermEvictTemplate = {
  unit: string;
  nameVehical: string;
  licensePlate: string;
  vehicleRegistrationCertificateId: number;
  certificateOfInspectionId: number;
  grantPeriod: string;
  grantedArea: string;
  gateAway: string;
  exit: string;
  NumberOfVehicleLicensesIssued: string;
};

export const externalBusinessVehicleCardLongTermEvictTemplate: TemplatesValue<ExternalBusinessVehicleCardLongTermEvictTemplate> =
  {
    fileName: "DanhSachThongTinPhuongTienDaiHanGiaHan",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      {
        ...Team,
        header: "Đơn vị",
      },
      VehicleName,
      LicensePlate,
      VehicleRegistrationCertificateId,
      CertificateOfInspectionId,
      GrantPeriod,
      GrantedArea,
      GateAway,
      Exit,
      NumberOfVehicleLicensesIssued,
    ],
    fields: [
      "unit",
      "nameVehical",
      "licensePlate",
      "vehicleRegistrationCertificateId",
      "certificateOfInspectionId",
      "grantPeriod",
      "grantedArea",
      "gateAway",
      "exit",
      "NumberOfVehicleLicensesIssued",
    ],
  };
